<div class="pos-panel">
    <div class="d-flex align-items-center justify-content-between" style="margin-top: 12px">
        <div class="pos-header-detailed">
            <span class="material-icons-round neutral-90 soc-cursor-pointer" (click)="goToTurnoverRecords()">arrow_back</span>
            <span class="soc-h3-light">{{'TURNOVER.BILL' | translate}}</span>
            <span class="soc-h3-light soc-neutral-50-text-color">{{bill.billNumber}}</span> 
            <span class="soc-pill-lbl" [ngClass]="{'soc-green-pill-outline': bill.statusType != BillStatus.Paid , 'soc-danger-pill-outline': (bill.statusType == BillStatus.Active || bill.statusType == BillStatus.Printed) }">{{('ORDER_BILL.' + bill.statusType) | uppercase | translate}}</span>
            <div class="soc-wrapper-gap-12 align-items-center">
                <span [ngClass]="bill.typeString == 'Fiscal' ? 'soc-fiscal' : 'soc-thermal'"></span>
                <span class="soc-p">{{(bill.typeString == 'Fiscal' ? 'ORDER_BILL.FISCAL': 'ORDER_BILL.THERMAL') | translate}}</span>
            </div>
        </div>
        <div class="soc-wrapper-gap-12">
            <div class="flex-column soc-wrapper-gap-8 align-items-end">
                <span class="soc-h1">{{bill.waiter?.firstName}} {{bill.waiter?.lastName}}</span>
                <span class="soc-p soc-secondary-text">Waiter</span>
            </div>
            <img alt="User Image" class="soc-employee-img" [src]="bill.waiter?.profilePictureUrl ? bill.waiter?.profilePictureUrl : 'assets/images/logo/profile-picture-placeholder.png'">
        </div>
    </div>
    <div class="d-flex justify-content-between">
        <div class="soc-info-grid">
            <div class="soc-wrapper-gap-12">
                <span class="material-icons cyan">calendar_month</span>
                <span class="soc-p">{{bill.createdOn | date: 'EEE, d MMM y'}}</span>
            </div>
            <div class="soc-wrapper-gap-12">
                <span class="material-icons cyan">room_service</span>
                <span class="soc-p">{{bill.groupName}}</span>
            </div>
            <div class="soc-wrapper-gap-12">
                <span class="material-icons cyan">watch_later</span>
                <span class="soc-p">{{bill.createdOn | date: 'hh:mm a'}}</span>
            </div>
            <div class="soc-wrapper-gap-12">
                <span class="material-icons cyan">table_bar</span>
                <span class="soc-p">{{billTables}} </span>
            </div>
        </div>
        <div class="soc-input-wrapper" style="width: 324px;">
            <label class="soc-input-lbl w-100 text-start">{{'ORDER_BILL.ORDERS' | translate}}</label>
             <p-dropdown appendTo="body" class="soc-dropdown soc-dropdown-search-separator soc-dropdown-btn-separator" [virtualScroll]="true" [filter]="true" [options]="bill.orders ? bill.orders : []"  optionLabel="orderNumber" placeholder="{{bill.orders?.length}} {{'ORDER_BILL.ORDERS'| translate}}" filterPlaceholder="{{'SEARCH' | translate}}">
                <ng-template let-item pTemplate="item">
                    <div class="d-flex justify-content-between" (click)="$event.stopPropagation(); goToOrder(item);">
                        <div class="soc-wrapper-gap-8">
                            <span>{{item.orderNumber}}</span>
                            <span class="pi pi-circle-fill soc-cyan-dot-separator"></span>
                             <span class="soc-secondary-text">{{item.netAmount}}</span>
                        </div>
                        <span class="material-icons">navigate_next</span>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
    </div>
   <p-table class="soc-table align-self-center w-100" [value]="bill.lineItems ? bill.lineItems : []" [scrollable]="true" [virtualScroll]="true" scrollHeight="calc(100vh - 568px)">
        <ng-template pTemplate="header">
            <tr> 
                <th [style.max-width]="'264px'">{{'TURNOVER.ITEMS' | translate}} <span class="secondary-td">({{ bill.lineItems?.length}})</span></th> 
                <th>{{'TURNOVER.DIVISION' | translate}}</th> 
                <th [style.max-width]="'120px'">{{'TURNOVER.NET' | translate}}</th> 
                <th [style.max-width]="'120px'">{{'TURNOVER.TAX' | translate}}</th> 
                <th [style.max-width]="'120px'">{{'TURNOVER.TOTAL' | translate}}</th> 
            </tr> 
        </ng-template>
        <ng-template  pTemplate="body" let-lineItem  let-rowIndex="rowIndex">  
                <tr>
                    <td [style.max-width]="'264px'">{{lineItem.menuItem.name}}</td>
                    <td>{{lineItem.division.name}}</td>
                    <td [style.max-width]="'120px'" class="secondary-td">{{currency.shortName ? (lineItem.menuItem.netPrice | currency: currency.shortName : true : '1.2-2' ) : (lineItem.menuItem.netPrice | number : '1.2-2')}}</td>
                    <td [style.max-width]="'120px'"class="secondary-td">{{currency.shortName ? (lineItem.menuItem.tax | currency: currency.shortName : true : '1.2-2' ) : (lineItem.menuItem.tax | number : '1.2-2')}}</td>
                    <td [style.max-width]="'120px'" class="secondary-td">{{currency.shortName ? (lineItem.menuItem.price | currency: currency.shortName : true : '1.2-2' ) : (lineItem.menuItem.price | number : '1.2-2')}}</td>
                </tr>                       
        </ng-template>
    </p-table>

    <div class="d-flex justify-content-between">
        <div class="soc-wrapper-gap-24">
            <div [style.max-width]="'96px'" class="soc-display-field-wrapper">
                <label class="soc-input-lbl">{{'TURNOVER.METHOD' | translate }}</label>
                <div class="soc-display-field"> <span class="soc-display-text">{{(bill.paidWithCard && bill.paidWithCash ? 'ORDER_BILL.COMBINED' : bill.paidWithCard ? 'ORDER_BILL.CARD' : bill.paidWithCash ?  'ORDER_BILL.CASH' : '-') | translate}}</span></div>
            </div>
            <div [style.max-width]="'96px'" class="soc-display-field-wrapper">
                <label class="soc-input-lbl">{{'TURNOVER.TENDER' | translate }}</label>
                <div class="soc-display-field"> 
                    <span class="soc-display-text">{{bill.statusType == BillStatus.Paid ? (currency.shortName ?  (amountPaid | currency : currency.shortName : true : '1.2-2') : (amountPaid  | number : '1.2-2')) : '-'}}</span>
                </div>
            </div>
            <div [style.max-width]="'96px'" class="soc-display-field-wrapper">
                <label class="soc-input-lbl">{{'TURNOVER.DISCOUNT' | translate }}</label>
                <div class="soc-display-field"> <span class="soc-display-text">{{bill.statusType ==  BillStatus.Paid ? (currency.shortName ?  (bill.discount | currency : currency.shortName : true : '1.2-2') : (bill.discount| number : '1.2-2')) : '-'}}</span></div>
            </div>
        </div>
        <div class="soc-wrapper-gap-24">
            <div [style.max-width]="'96px'" class="soc-display-field-wrapper">
                <label class="soc-input-lbl text-end">{{'TURNOVER.SUM' | translate }}</label>
                <div class="soc-display-field justify-content-end"> <span class="soc-display-text">{{currency.shortName ? ((bill.sum ? bill.sum : '') | currency : currency.shortName: true : '1.2-2') : ((bill.sum ? bill.sum : '') | number : '1.2-2')}}</span></div>
            </div>
            <div [style.max-width]="'96px'" class="soc-display-field-wrapper">
                <label class="soc-input-lbl text-end">{{'TURNOVER.TAX' | translate }}</label>
                <div class="soc-display-field justify-content-end"> <span class="soc-display-text">{{currency.shortName ? (bill.taxAmount | currency : currency.shortName : true : '1.2-2') : (bill.taxAmount | number : '1.2-2')}}</span></div>
            </div>
            <div [style.max-width]="'144px'" class="soc-display-field-wrapper">
                <label class="soc-input-lbl text-end">{{'TURNOVER.ORDER_TOTAL' | translate }}</label>
                <div class="soc-display-field justify-content-end"> <span class="soc-h2 soc-success-color">{{ currency.shortName ? ( bill.total | currency : currency.shortName : true : '1.2-2') : ( bill.total | number : '1.2-2')}}</span></div>
            </div>
        </div>
    </div>
</div>

        